import { useEffect, useState, useRef } from 'react';
import { Container, Row } from 'react-bootstrap';

import { useStoreState, useStoreActions } from 'easy-peasy';

import Header from '../../layout/Header/index.jsx';
import SideMenu from "../../layout/SideMenu/index.jsx";
import Main from "../../layout/Main/index.jsx";
import WelcomeBannerComponent from '../../components/welcomeMessage/WelcomeBannerComponent';
import HelpCenterWidget from '../../components/widgets/helpCenter/HelpCenterWidget.jsx';

import './LayoutPage.scss';

const LayoutPage = () => {
	const { apiData } = useStoreState(state => state.actionSlugs);
	const { fetchActiveMessage } = useStoreActions(actions => actions.welcomeMessage);

	const [banner, setBanner] = useState();

	const [bannerHeight, setBannerHeight] = useState(0);
	const bannerRef = useRef(null);

	useEffect(() => {
		if (bannerRef.current) {
			setBannerHeight(bannerRef.current.clientHeight);
		} else {
			setBannerHeight(null);
		}
	}, [banner]);

	useEffect(() => {
		if (apiData) fetchActiveMessage().then((msg) => setBanner(msg.data));
	}, [apiData]);

    const backgroundColor = process.env.REACT_APP_CONTEXT === 'dev' ? "#521016" : "#021f3f";

	return (
		<div className='app'>
			{banner && <div ref={bannerRef}>< WelcomeBannerComponent message={banner} setBanner={setBanner} /></div>}
			<Container fluid>
				<Row>
                    <SideMenu dynamicStyle={{ paddingTop: bannerHeight ?? 20, backgroundColor }} />
                    <Header dynamicStyle={{ backgroundColor }} />
                    <Main />
				</Row>
			</Container>
			<HelpCenterWidget />
		</div>
	);
}

export default LayoutPage;